import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { pagesModel } from '../model';
import { foldersModel } from '../../folders/model';

import { WORKSPACE_FOLDER_ROUTE } from '../../../entities/history';

import { pageCreationFlowModel } from '../../../processes/page-creation-flow';

export const useCreatePage = () => {
  const dispatch = useDispatch();

  const isWorkspaceFolderPage = useRouteMatch({
    path: WORKSPACE_FOLDER_ROUTE,
    exact: true,
  });

  const handleCreateNewPage = useCallback(() => {
    if (!isWorkspaceFolderPage) {
      // Reused from workspaceSaga main saga
      dispatch(foldersModel.actions.setCurrentFolder(undefined));
      dispatch(pagesModel.actions.setCurrentPage(undefined));
      dispatch(pagesModel.actions.setCurrentContentId(undefined));
    }

    dispatch(pageCreationFlowModel.actions.openPageCreationFlow({}));
  }, [dispatch, isWorkspaceFolderPage]);

  return { handleCreateNewPage };
};
